module.exports = __webpack_public_path__ + "img/duels.7871ae8d.jpg";